import safeStorage from '@github-ui/safe-storage'

export const safeSessionStorage = safeStorage('sessionStorage')
